import apiClient from '../utils/apiClient';
import { idempotentPost } from '../utils/idempotentStockPosting';
export const getStockControl = async () => (await apiClient.get('/stock/controls/state',{withCredentials:true})).data;
export const getStockReports = async (params={}) => (await apiClient.get('/stock/controls/reconciliations',{params,withCredentials:true})).data;
export const getStockReport = async (id,params={}) => (await apiClient.get(`/stock/controls/reconciliations/${id}`,{params,withCredentials:true})).data;
export const getStockPerformance = async () => (await apiClient.get('/stock/controls/metrics',{withCredentials:true})).data;
export const stockControlAction = async (action,payload) => {
 if(!['close','reopen','reconcile'].includes(action))throw new Error('Invalid stock control action.');
 return (await idempotentPost(apiClient,`/stock/controls/${action}`,payload,{withCredentials:true})).data;
};
